import Typography from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import { COLORS, TYPOGRAPHY } from "@tSurya/theme/design";
import { css } from "styled-components";

export default {
    defaultProps: {
        cssOverrides: {
            table: css`
                background-color: ${COLORS.background.grey};
                width: 100%;
            `,
            head: css`
                th {
                    white-space: normal;
                    font-family: ${TYPOGRAPHY.fontFamily.base};
                    font-style: normal;
                    font-weight: ${TYPOGRAPHY.weight.bold};
                    font-size: ${TYPOGRAPHY.size.tiny};
                    line-height: 130%;
                    text-align: center;
                    color: ${getColor("text.main")};
                    border: 1px solid ${getColor("common.border")};
                    background-color: ${COLORS.background.grey};
                }
            `,
            body: css`
                td {
                    font-family: ${TYPOGRAPHY.fontFamily.base};
                    font-style: normal;
                    font-weight: ${TYPOGRAPHY.weight.base};
                    font-size: ${TYPOGRAPHY.size.smaller};
                    line-height: 130%;
                    text-align: center;
                    border: 1px solid ${getColor("common.border")};
                    color: ${getColor("text.main")};
                    background-color: ${COLORS.background.grey};
                }
            `,
        },
    },
};
